<template>
  <div class="china-map-container">
    <div class="china-map" id="china-map"></div>
    <mapShowDetail :detail="currentId" :recordedIn="RecordedIn" :personData="personData" :nativePlaceList="nativePlaceList" @close="close" @tab-change="tabChange" />
    <div class="china-map-sidebar" v-if="personName">
      <div v-for="(row, index) in mapCord" :key="index">
        <img :src="row.icon" alt="">
        <p>{{ row.name }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import tjdPng from '@/assets/map/tjd.png'
import zxdPng from '@/assets/map/zxd.png'
import gjdPng from '@/assets/map/jgd.png'
import { getRecordedIn } from '@/api/home'
import { Message } from 'element-ui'
import { i18n } from '@/i18n'
export default {
  name: 'chinaMap',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    personName: {
      type: String,
      default: ''
    },
    nativePlaceList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mapCord: [
        { name: '籍贯地', icon: gjdPng },
        { name: '途径地', icon: tjdPng },
        { name: '驻锡地', icon: zxdPng }
      ],
      TMap: window.TMap,
      map: null,
      currentId: null,
      multiCircle: null,
      zoom: 4,
      timeout: null,
      personCircle: null,
      multiLabel: null,
      multiPolyline: null,
      perLatLng: [33.657003, 97.494722],
      RecordedIn: null,
      personData: null
    }
  },
  watch: {
    list: {
      async handler (val) {
        if (this.multiPolyline) {
          await this.multiPolyline.setMap(null)
        }
        if (this.personCircle) {
          await this.personCircle.setMap(null)
        }
        if (this.multiLabel) {
          await this.multiLabel.destroy()
        }
        if (this.multiCircle) {
          await this.multiCircle.setMap(null)
        }
        this.setMark()
      },
      deep: true
    }
  },
  mounted () {
    this.initMap()
  },
  async destroyed () {
    if (this.multiPolyline) {
      await this.multiPolyline.setMap(null)
    }
    if (this.personCircle) {
      await this.personCircle.setMap(null)
    }
    if (this.multiLabel) {
      await this.multiLabel.destroy()
    }
    if (this.multiCircle) {
      await this.multiCircle.setMap(null)
    }
    await this.map.destroy()
  },
  methods: {
    tabChange (Id) {
      this.$emit('tab-change', Id)
    },
    close () {
      if (this.currentId) {
        if (!this.personName && this.multiCircle) {
          this.multiCircle.updateGeometries([{
            ...this.currentId,
            center: new this.TMap.LatLng(this.currentId.center.lat, this.currentId.center.lng),
            radius: this.currentId.radius,
            styleId: 'default'
          }])
        }
      }
      this.RecordedIn = null
      this.currentId = null
      this.personData = null
    },
    initMap () {
      const center = new this.TMap.LatLng(39.916527, 116.397128)
      this.map = new this.TMap.Map('china-map', { // 地图初始化配置
        pitch: 0,
        rotation: 0,
        zoom: 4,
        maxZoom: 18,
        minZoom: 4,
        center: center,
        showControl: false,
        feature: {
          label: {
            text: {
              visibility: 'off'
            }
          },
          boundary: {
            visibility: 'off'
          }
        }
      })
      this.map.setBaseMap({ type: 'satellite' })
      this.setMark()
    },
    setMark () {
      if (this.personName) {
        let radius = (200000 + ((4 - this.zoom) / 4 * 200000))
        if (radius <= 1) {
          radius = 1
        }
        // 人物点
        this.personCircle = new this.TMap.MultiCircle({
          map: this.map,
          zIndex: 9999,
          styles: {
            default: new this.TMap.CircleStyle({
              color: '#2868F4', // 半透明底色
              showBorder: true,
              // borderColor: '#FBF939',
              borderWidth: 0
            })
          },
          geometries: [
            {
              center: new this.TMap.LatLng(...this.perLatLng),
              radius: radius < 10 ? 10000 : radius, // 单位：米
              styleId: 'default'
            }
          ]
        })
        // 名称
        this.multiLabel = new this.TMap.MultiLabel({
          map: this.map,
          zIndex: 9999,
          styles: {
            'count-style': new this.TMap.LabelStyle({
              color: '#ffffff',
              fontSize: 10 / this.zoom,
              textAlign: 'center'
            })
          },
          geometries: [
            {
              position: new this.TMap.LatLng(...this.perLatLng),
              styleId: 'count-style',
              content: this.personName
            }
          ]
        })
        // 连线
        this.multiPolyline = new this.TMap.MultiPolyline({
          map: this.map,
          styles: {
            style_blue: new this.TMap.PolylineStyle({
              color: '#E2DACF',
              width: 2,
              borderWidth: 5,
              borderColor: 'rgba(255,255,255,0)',
              lineCap: 'round'
            })
          },
          geometries: this.list.map(e => ({
            styleId: 'style_blue',
            ...e,
            paths: [
              new this.TMap.LatLng(...this.perLatLng),
              new this.TMap.LatLng(e.Latitude, e.Longitude)
            ]
          }))
        })
        let pngW = (24 + ((4 - this.zoom) / 4 * 24))
        if (pngW <= 24 * 0.7) {
          pngW = 24 * 0.7
        }
        if (pngW >= 24 * 0.9) {
          pngW = 24 * 0.9
        }
        let pngH = (34 + ((4 - this.zoom) / 4 * 34))
        if (pngH <= 34 * 0.7) {
          pngH = 34 * 0.7
        }
        if (pngH >= 34 * 0.9) {
          pngH = 34 * 0.9
        }
        // 籍贯地 途经地 驻锡地 处理层级
        const addList = JSON.parse(JSON.stringify(this.list))
        const list1 = addList.filter(e => {
          return e.markers.value === i18n.$t('籍贯地')
        })
        const list2 = addList.filter(e => {
          return e.markers.value === i18n.$t('途经地')
        })
        const list3 = addList.filter(e => {
          return e.markers.value === i18n.$t('驻锡地')
        })
        // 驻锡地 途经地 籍贯地
        this.multiCircle = new this.TMap.MultiMarker({
          map: this.map,
          styles: {
            'tjd-icon': new this.TMap.MarkerStyle({
              width: pngW, // 图标宽度
              height: pngH, // 图标高度
              anchor: { x: pngW / 2, y: pngH / 2 }, // 锚点位置（底部居中）
              src: tjdPng // 本地图片路径
            }),
            'gjd-icon': new this.TMap.MarkerStyle({
              width: pngW, // 图标宽度
              height: pngH, // 图标高度
              anchor: { x: pngW / 2, y: pngH / 2 }, // 锚点位置（底部居中）
              src: gjdPng // 本地图片路径
            }),
            'zxd-icon': new this.TMap.MarkerStyle({
              width: pngW, // 图标宽度
              height: pngH, // 图标高度
              anchor: { x: pngW / 2, y: pngH / 2 }, // 锚点位置（底部居中）
              src: zxdPng // 本地图片路径
            })
          },
          geometries: [
            ...list3,
            ...list2,
            ...list1
          ].map(item => ({
            ...item,
            styleId: `${item.markers.value === i18n.$t('驻锡地') ? 'zxd' : (item.markers.value === i18n.$t('途经地') ? 'tjd' : 'gjd')}-icon`,
            position: new this.TMap.LatLng(item.Latitude, item.Longitude),
            properties: { // 自定义属性（点击时使用）
              id: item.id,
              type: 'custom'
            }
          }))
        })
      } else {
        this.multiCircle = new this.TMap.MultiCircle({
          map: this.map,
          zIndex: 9999,
          styles: {
            default: new this.TMap.CircleStyle({
              color: '#FBF939', // 半透明底色
              showBorder: true,
              // borderColor: '#FBF939',
              borderWidth: 0
            }),
            light: new this.TMap.CircleStyle({
              color: '#F5364B', // 半透明底色
              showBorder: true,
              // borderColor: '#F5364B',
              borderWidth: 0
            })
          },
          geometries: this.list.map(e => ({
            ...e,
            position: new this.TMap.LatLng(e.Latitude, e.Longitude), // 上海
            value: e.relation_count,
            color: '#FBF939' // 保持与现有UI一致
          })).map(marker => {
            // 基础半径：使用1.8的底数，缩放更平缓，保持视觉恒定像素大小
            const baseRadius = 60000 / Math.pow(1.8, this.zoom - 4)
            // relation_count 影响：归一化后在 0.5-2 倍之间调整
            const maxCount = Math.max(...this.list.map(e => e.relation_count || 1))
            const countFactor = 0.5 + (marker.value / maxCount) * 1.5
            let radius = baseRadius * countFactor
            if (radius <= 50) {
              radius = 50
            }
            return {
              ...marker,
              center: marker.position,
              radius: radius, // 单位：米
              styleId: 'default'
            }
          })
        })
      }
      this.map.on('zoom_changed', e => {
        this.zoom = e.zoom
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(async () => {
          if (this.multiPolyline) {
            await this.multiPolyline.setMap(null)
          }
          if (this.personCircle) {
            await this.personCircle.setMap(null)
          }
          if (this.multiLabel) {
            await this.multiLabel.destroy()
          }
          if (this.multiCircle) {
            await this.multiCircle.setMap(null)
          }
          this.setMark()
        }, 500)
      })
      this.map.on('click', (e) => {
        if (!e.originalEvent.geometry && !e.originalEvent.isOverlayClick) {
          this.close()
        }
      })
      if (this.multiCircle) {
        this.multiCircle.on('click', (e) => {
          this.RecordedIn = null
          this.personData = null
          e.originalEvent.isOverlayClick = true
          e.originalEvent.stopPropagation()
          const geometry = JSON.parse(JSON.stringify(e.geometry))
          if (!this.personName) {
            const list = [
              {
                ...geometry,
                center: new this.TMap.LatLng(geometry.center.lat, geometry.center.lng),
                radius: geometry.radius,
                styleId: 'light'
              }
            ]
            if (this.currentId) {
              list.push({
                ...this.currentId,
                center: new this.TMap.LatLng(this.currentId.center.lat, this.currentId.center.lng),
                radius: this.currentId.radius,
                styleId: 'default'
              })
            }
            this.multiCircle.updateGeometries(list)
          }
          if (!this.currentId || (this.currentId && this.currentId.id !== geometry.id)) {
            this.currentId = geometry
          } else {
            this.currentId = null
          }
        })
      }
      if (this.multiPolyline) {
        this.multiPolyline.on('click', (e) => {
          const { markers } = e.geometry
          if (markers && markers.RecordedIn) {
            getRecordedIn({
              recorded_in: markers.RecordedIn
            }).then(res => {
              this.RecordedIn = res.data.data
            })
          } else {
            Message.warning(i18n.$t('暂无记载'))
          }
        })
      }
      if (this.personCircle) {
        this.personCircle.on('click', (e) => {
          setTimeout(() => {
            this.personData = {
              name: this.personName,
              labels: 'Person'
            }
          }, 500)
        })
      }
      if (this.multiLabel) {
        this.multiLabel.on('click', (e) => {
          setTimeout(() => {
            this.personData = {
              name: this.personName,
              labels: 'Person'
            }
          }, 500)
        })
      }
    }
  }
}
</script>
<style lang="scss">
.china-map-container {
  width: 100%;
  height: 100%;
  position: relative;
  .china-map-sidebar {
    position: absolute;
    right: 10px;
    bottom: 10px;
    background-color: rgba($color: #ffffff, $alpha: 0.2);
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    > div {
      display: flex;
      align-items: center;
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
      img {
        height: 20px;
        margin-right: 10px;
      }
      p {
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}
.china-map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  a,
  .logo-text {
    display: none!important;
  }
}
</style>
